import pulse from '@finn-no/pulse-sdk';

function main() {
    pulse.trackPageView({
        object: {
            type: 'Page',
            pageType: 'search',
        },
        vertical: {
            name: 'common_pages',
        },
    });
}

main();
